import { css } from 'styled-components';

const ELEVATIONS = {
  200: '0px 2px 4px rgba(104, 119, 134, 0.2)',
  300: '0px 4px 8px rgba(104, 119, 134, 0.2)',
};

export const elevation = (options = {}) =>
  options.level &&
  css`
    filter: drop-shadow(${ELEVATIONS[options.level]});
  `;
